import { graphql } from "api/cms-website/generated";

import { ButtonFragment } from "../primitives/button";
import { IconFragment } from "../primitives/icon";

export const VerticalListSectionFragment = graphql(/* GraphQL */ `
    fragment VerticalListSectionFragment on ComponentComponentsVerticalListSection {
        id
        noMarginBottom
        verticalListSectionTitle: title
        verticalListSectionSubtitle: subtitle
        verticalListSectionCta: cta {
            ...ButtonFragment
        }
        verticalListSectionItems: items {
            title
            texts {
                text
            }
            icon {
                ...IconFragment
            }
        }
    }
    ${ButtonFragment}
    ${IconFragment}
`);
